import config from "#src/config";
import { getUTCTimeString } from "#utils/timeFormatter";

export function formatDailyVolumeDate(date) {
  return getUTCTimeString(date, config.DATE_FORMAT);
}
